// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.controlpanel-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
}

.controlpanel-title {
    font-size: 28px;
    margin-top: 25px;
    margin-bottom: 25px;
    text-align: center;
    font-family: "Rigidica Text Regular", sans-serif;
}

.controlpanel-tabs {
    display: flex;
    overflow-x: auto;
    margin-bottom: 25px;
    border-bottom: 1px solid #ddd;
}

.controlpanel-tab {
    padding: 12px 20px;
    background: none;
    border: none;
    border-bottom: 3px solid transparent;
    font-size: 16px;
    font-family: "Rigidica Text Regular", sans-serif;
    cursor: pointer;
    white-space: nowrap;
    transition: all 0.3s ease;
}

.controlpanel-tab:hover {
    background-color: #f5f5f5;
    color: #333;
}

.controlpanel-tab-active {
    border-bottom: 3px solid #333;
    font-weight: bold;
}

.controlpanel-content {
    background-color: #fff;
    border-radius: 6px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    padding: 20px;
}

.controlpanel-placeholder {
    text-align: center;
    padding: 100px 0;
    color: #888;
    font-style: italic;
}`, "",{"version":3,"sources":["webpack://./src/styles/ControlPanelPage.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,gDAAgD;AACpD;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,oCAAoC;IACpC,eAAe;IACf,gDAAgD;IAChD,eAAe;IACf,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;IACxC,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB","sourcesContent":[".controlpanel-container {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 20px;\n}\n\n.controlpanel-title {\n    font-size: 28px;\n    margin-top: 25px;\n    margin-bottom: 25px;\n    text-align: center;\n    font-family: \"Rigidica Text Regular\", sans-serif;\n}\n\n.controlpanel-tabs {\n    display: flex;\n    overflow-x: auto;\n    margin-bottom: 25px;\n    border-bottom: 1px solid #ddd;\n}\n\n.controlpanel-tab {\n    padding: 12px 20px;\n    background: none;\n    border: none;\n    border-bottom: 3px solid transparent;\n    font-size: 16px;\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    cursor: pointer;\n    white-space: nowrap;\n    transition: all 0.3s ease;\n}\n\n.controlpanel-tab:hover {\n    background-color: #f5f5f5;\n    color: #333;\n}\n\n.controlpanel-tab-active {\n    border-bottom: 3px solid #333;\n    font-weight: bold;\n}\n\n.controlpanel-content {\n    background-color: #fff;\n    border-radius: 6px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    padding: 20px;\n}\n\n.controlpanel-placeholder {\n    text-align: center;\n    padding: 100px 0;\n    color: #888;\n    font-style: italic;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
